<template>
    <div v-if="is_loading_provider">
        <cc-loader-full />
    </div>
    <div v-else class="makeorder-page">
        <div class="page-route-select not-print">
            <router-link to="/cliente/monitores/cotacoes" class="page-route-select-text">
                Home
            </router-link>
            <span class="material-icons page-route-select-icon">play_arrow</span>
            <router-link to="/cliente/monitores/cotacoes" class="page-route-select-text">
                Monitor de Cotação
            </router-link>
            <span class="material-icons page-route-select-icon">play_arrow</span>
            <router-link :to="'/cliente/monitores/vencedores/' + $route.params.id" class="page-route-select-text">
                Comparativo de Preço
            </router-link>
            <span class="material-icons page-route-select-icon">play_arrow</span>
            <div class="page-route-select-text">Não Digitados</div>
        </div>
        <div class="makeorder-page-title-container">
            <div class="makeorder-page-title">
                <div>Realizar Pedido</div>
                <div class="makeorder-page-subtitle">Cotação #{{ $route.params.id }}</div>
            </div>
            <div class="not-print">
                <span class="material-icons-outlined makeorder-page-title-icons"
                    @click="navigate_provider(-1)">skip_previous</span>
                <span class="material-icons-outlined makeorder-page-title-icons" @click="navigate_provider(1)"
                    style="margin-left: 1vw">skip_next</span>
            </div>
        </div>
        <div class="makeorder-page-info-container">
            <div class="makeorder-page-info-texts">
                <div class="makeorder-page-info-buyer-colum">
                    <div class="makeorder-page-info-buyer-title-text">Comprador</div>
                    <div class="makeorder-page-info-text">
                        {{ current_subrequest.loj_nomeFantasia.toUpperCase() }}
                    </div>
                    <div class="makeorder-page-info-text">
                        {{ current_subrequest.loj_endereco }}, {{ current_subrequest.loj_bairro }} -
                        {{ current_subrequest.cid_nome }}/{{ current_subrequest.est_sigla }}
                    </div>
                    <div class="makeorder-page-info-suplier-raiting">
                        <div class="makeorder-page-info-subtitle">Fone:</div>
                        <a class="makeorder-page-info-text" v-if="current_subrequest.loj_telefone" :href="'https://api.whatsapp.com/send?phone=' +
                            formatNumber(current_subrequest.loj_telefone)
                            " target="_blank">{{ current_subrequest.loj_telefone | VMask("(##) #####-####") }}</a>
                        <div class="makeorder-page-info-text" v-else>--</div>
                    </div>
                    <div class="makeorder-page-info-suplier-raiting">
                        <div class="makeorder-page-info-subtitle">CNPJ:</div>
                        <div class="makeorder-page-info-text">
                            {{ current_subrequest.loj_cnpj | cnpj }}
                        </div>
                    </div>
                </div>
                <div class="makeorder-page-info-suplier-colum">
                    <div class="makeorder-page-info-buyer-title-text">Fornecedor</div>
                    <div class="makeorder-page-info-suplier-raiting">
                        <div class="makeorder-page-info-suplier-raiting-text">
                            {{ current_subrequest.for_nome }}
                        </div>
                        <span class="material-icons-outlined makeorder-page-info-suplier-raiting-icon">grade</span>
                        <div>{{ current_subrequest.rate.toFixed(1) }}</div>
                    </div>
                    <div class="makeorder-page-info-text">{{ current_subrequest.usu_nome }}</div>
                    <div class="makeorder-page-info-subtitle" style="margin-top: 1.5vh">
                        E-mail:
                    </div>
                    <div class="makeorder-page-info-text">{{ current_subrequest.usu_email }}</div>
                    <div class="makeorder-page-info-suplier-raiting">
                        <div class="makeorder-page-info-subtitle">CNPJ:</div>
                        <div v-if="providerCnpj" class="makeorder-page-info-text">
                            {{ providerCnpj | cnpj }}
                        </div>
                    </div>
                    <div class="makeorder-page-info-suplier-raiting">
                        <div class="makeorder-page-info-subtitle">Fone:</div>
                        <img class="makeorder-page-info-whats-icon" src="@/assets/WhatsApp_black.svg"
                            alt="mandar mensagem" />
                        <a class="makeorder-page-info-text" v-if="current_subrequest.usu_telefone" :href="'https://api.whatsapp.com/send?phone=' +
                            formatNumber(current_subrequest.usu_telefone)
                            " target="_blank">{{ current_subrequest.usu_telefone | VMask("(##) #####-####") }}</a>
                        <div class="makeorder-page-info-text" v-else>--</div>
                    </div>
                </div>
                <div :class="{ 'extra-margin': !showDetailsMobile }" class="makeorder-page-info-details-colum">
                    <div style="display: flex; align-items: center" v-on:click="showDetailsMobile = !showDetailsMobile">
                        <span style="color: var(--primary-color)" v-if="showDetailsMobile"
                            class="material-icons-outlined mobile">expand_more</span>
                        <span v-else class="material-icons-outlined mobile"
                            style="rotate: -90deg; color: var(--primary-color)">expand_more</span>
                        <div class="makeorder-page-info-buyer-title-text">Detalhe do Pedido</div>
                        <span @click="showEditDetails = current_subrequest"
                            class="material-icons-outlined edit-order-details-icon">edit</span>
                    </div>

                    <div :class="{ desktop: !showDetailsMobile }" class="makeorder-page-info-suplier-raiting">
                        <div class="makeorder-page-info-subtitle">Entrega:</div>
                        <div class="makeorder-page-info-text">
                            {{ current_subrequest.data_entrega | formatDateOnly }}
                        </div>
                    </div>
                    <div :class="{ desktop: !showDetailsMobile }" class="makeorder-page-info-suplier-raiting">
                        <div class="makeorder-page-info-subtitle">Tipo de Entrega:</div>
                        <div class="makeorder-page-info-text">{{ current_subrequest.tpc_nome }}</div>
                    </div>
                    <div :class="{ desktop: !showDetailsMobile }" class="makeorder-page-info-suplier-raiting">
                        <div class="makeorder-page-info-subtitle">Faturamento:</div>
                        <div class="makeorder-page-info-text">
                            {{ current_subrequest.faturamento_minimo | currency }}
                        </div>
                    </div>
                    <div :class="{ desktop: !showDetailsMobile }" class="makeorder-page-info-suplier-raiting">
                        <div class="makeorder-page-info-subtitle">Cond. de Pgto:</div>
                        <div class="makeorder-page-info-text">{{ current_subrequest.forma }}</div>
                        <span v-if="showPaymentConditionAlert(current_subrequest)" class="payment-condition-alert"
                            title="Condição de pagamento diferente da selecionada no pedido">
                            !
                        </span>
                    </div>
                    <div :class="{ desktop: !showDetailsMobile }" class="makeorder-page-info-suplier-raiting">
                        <div class="makeorder-page-info-subtitle">Status:</div>
                        <div v-if="!current_subrequest.id_pedido" class="makeorder-page-info-status-pending">
                            pendente
                        </div>
                        <div v-else class="makeorder-page-info-status-created">gerado</div>
                    </div>
                    <div v-if="current_subrequest.id_pedido" :class="{ desktop: !showDetailsMobile }"
                        class="makeorder-page-info-suplier-raiting">
                        <div class="makeorder-page-info-subtitle">Nº do Pedido</div>
                        <div class="makeorder-page-info-text">{{ current_subrequest.id_pedido }}</div>
                    </div>
                </div>
            </div>

            <div :class="{ desktop: !showDetailsMobile }" class="makeorder-page-info-obs-colum">
                <div class="makeorder-page-info-buyer-title-text makeorder-page-info-obs-title-container">
                    Observação
                    <span v-if="
                        can('REQUEST_ORDER', 'CREATE') &&
                        !current_subrequest.id_pedido &&
                        backRoute == 1
                    " @click="save_request_detail_obs"
                        class="material-icons-outlined makeorder-page-info-obs-title-icon">save</span>
                    <span v-if="
                        can('REQUEST_ORDER', 'CREATE') &&
                        !current_subrequest.id_pedido &&
                        backRoute == 1 &&
                        isTextObs
                    " @click="isTextObs = false" class="material-icons-outlined makeorder-page-info-edit-icon">article</span>
                    <span v-if="
                        can('REQUEST_ORDER', 'CREATE') &&
                        !current_subrequest.id_pedido &&
                        backRoute == 1 &&
                        !isTextObs
                    " @click="isTextObs = true"
                        class="material-icons-outlined makeorder-page-info-edit-icon">text_fields</span>
                </div>
                <textarea v-if="isTextObs" :disabled="current_subrequest.id_pedido && backRoute == 1"
                    class="makeorder-page-info-obs-textarea" placeholder="Digite aqui ser houver alguma observação"
                    cols="30" rows="8" v-model="current_subrequest.obs"></textarea>
                <div v-else>
                    <span class="makeorder-page-info-subtitle">Numero do evento:</span>
                    <input :disabled="current_subrequest.id_pedido && backRoute == 1" type="text"
                        v-model="obsForm.eventNumber" class="form-obs-input" />
                    <span class="makeorder-page-info-subtitle">Modelo do carro:</span>
                    <input :disabled="current_subrequest.id_pedido && backRoute == 1" type="text" v-model="obsForm.car"
                        class="form-obs-input" />
                    <span class="makeorder-page-info-subtitle">Endereço de entrega:</span>
                    <input :disabled="current_subrequest.id_pedido && backRoute == 1" type="text"
                        v-model="obsForm.address" class="form-obs-input" />
                    <span class="makeorder-page-info-subtitle">Numero do pix:</span>
                    <input :disabled="current_subrequest.id_pedido && backRoute == 1" type="text" v-model="obsForm.pix"
                        class="form-obs-input" />
                </div>
            </div>
        </div>
        <div class="makeorder-page-buttons-row">
            <StandardButton class="mobile" style="margin-bottom: 2vh" :action="sendBack" :iconName="'arrow_back'"
                :text="'Voltar'" />
            <div class="makeorder-buttons-container">
                <div class="makeorder-page-buttons-total">
                    <span class="material-icons-outlined makeorder-page-buttons-total-icon">attach_money</span>
                    Valor Total: {{ this.current_subrequest.total | currency }}
                </div>
                <div class="makeorder-page-buttons-balance">
                    Saldo:
                    {{
                        (current_subrequest.faturamento_minimo > this.current_subrequest.total
                            ? this.current_subrequest.total - current_subrequest.faturamento_minimo
                            : 0) | currency
                    }}
                </div>
                <div v-if="showPriceManager && varTotal != 0" :class="{
                    'report-total-minus': varTotal < 0,
                    'report-total-plus': varTotal >= 0,
                }" class="reports-page__title-button-total action-buttons-width">
                    <div style="display: flex; align-items: center">
                        <!-- <img class="preorder-seller-title-button-excel-icon" src="../../../assets/database-icon.png" alt="excel"> -->
                        {{ varTotal < 0 ? "Economia" : "Aumento" }}: {{ varTotal | currency }} </div>
                    </div>
                </div>

                <div class="makeorder-page-buttons-blank"></div>
                <StandardButton class="desktop not-print" :action="sendBack" :iconName="'arrow_back'"
                    :text="'Voltar'" />

                <div class="makeorder-buttons-container not-print">
                    <StandardButton v-if="!myStore" class="makeorder-page-button-right" :action="sendSuplier"
                        :iconName="'store'" :text="'Por Empresa'" />
                    <StandardButton v-if="showPriceManager" class="makeorder-page-button-right"
                        :action="sendPriceManager" iconName="price_check" text="Gestor de compra" />
                    <div class="makeorder-page-button-order" v-on:click="order" v-if="
                        can('REQUEST_ORDER', 'CREATE') &&
                        !current_subrequest.id_pedido &&
                        backRoute == 1
                    ">
                        <span class="material-icons-outlined makeorder-page-button-order-icon">shopping_cart</span>
                        Realizar Pedido
                    </div>
                    <div class="makeorder-page-button-cancelorder" :class="{ disabled: !canCancelOrder }"
                        @click="canCancelOrder ? cancel_order() : null" v-if="
                            can('REQUEST_ORDER', 'CREATE') &&
                            current_subrequest.id_pedido &&
                            backRoute == 1
                        ">
                        <span class="material-icons-outlined makeorder-page-button-cancelorder-icon">block</span>
                        Cancelar Pedido
                    </div>
                </div>
            </div>

            <div class="makeorder-page-buttons-row not-print">
                <StandardInput width="30%" type="text" class="desktop" :action="searchProducts"
                    placeholder="Digite o nome do Produto" />
                <StandardInput
                    v-if="showPriceManager && SECTION == 'TYPINGS'"
                    style="margin-left: 2vw"
                    :action="setPriceVariationFilter"
                    :width="'22%'"
                    :type="'select'"
                    :list="priceVariationOptions"
                    :placeholder="'Selecione a variação'"
                />
                <StandardInput width="100%" type="text" class="mobile" :action="searchProducts"
                    placeholder="Digite o nome do Produto" />
                <div class="makeorder-page-buttons-blank"></div>
                <StandardButton class="makeorder-page-button-right" style="margin-right: 1vw" :action="exportPdfOrder"
                    :iconName="'print'" :text="'Imprimir'" />
                <div class="makeorder-page-buttons-section" @click="toggleOrdersOnlyFilter('TYPINGS')"
                    :class="getActiveSection('TYPINGS')" style="cursor: pointer">
                    Itens do Pedido
                </div>
                <div class="makeorder-page-buttons-section" @click="toggleOrdersOnlyFilter('PRODUCTS')"
                    :class="getActiveSection('PRODUCTS')" style="margin-left: 1vw; cursor: pointer">
                    Todos Digitados
                </div>
                <div class="makeorder-page-buttons-section-green" :class="{ disabled: !canAddProductsNow() }"
                    v-if="can('REQUEST_ORDER', 'CREATE') && backRoute == 1"
                    @click="canAddProductsNow() ? openProductsModal() : null">
                    Adicionar Produto
                </div>
            </div>
            <div class="makeorder-page-table-container">
                <cc-typings v-if="SECTION == 'TYPINGS' && !is_loading_provider"
                    :key="$route.params.sid"
                    :subrequest="current_subrequest"
                    @reload_provider="reload_current_provider"
                    :priceVariationFilter="priceVariationFilter"
                    :setVarTotal="(value) => (varTotal = value)"
                    :filterProducts="search_terms"
                ></cc-typings>

                <cc-products v-if="SECTION == 'PRODUCTS'"
                    :page="page"
                    v-bind:products="products"
                    v-bind:sellers="sellers"
                    v-bind:loj_id="$route.params.sid"
                    v-bind:seller_id="$route.params.sellerid"
                    v-bind:is_loading="is_loading"
                    :updatePage="updateProductPage"
                    :total_items="total_items"
                    @loadProviders="reload_current_provider"
                ></cc-products>

                <ProductsMatrixComponent v-if="SECTION == 'MATRIX'" :id="$route.params.id" :min_fat="current_subrequest && current_subrequest.faturamento_minimo
                        ? parseFloat(current_subrequest.faturamento_minimo)
                        : 0
                    " :seller_id="$route.params.sellerid" :provider="current_subrequest" :reload="trigger" :is_loading="is_loading"
                    @update="update"></ProductsMatrixComponent>
            </div>
            <EditOrderDetails v-if="showEditDetails" :close="() => (showEditDetails = false)"
                :order="showEditDetails" />
            <a id="download-pdf" style="display: none"></a>
            <AddProductModal v-if="add_product" id="modal" @add_product="add_new_product"
                :seller_id="$route.params.sellerid" :store_id="$route.params.sid" :request_id="$route.params.id"
                :closeDialog="() => closeModal()" />
        </div>
</template>
<script>
import Button from "@/components/ui/buttons/button.component";
import Pagination from "@/components/cliente/base-components/Pagination";
import Typings from "@/components/lists/typings.componentV2";
import ProductsMatrixComponent from "./_products-matrix.component";
import * as CONSTANTS from "@/constants/constants";
import QuotationService from "@/services/QuotationService";
import OrderService from "@/services/OrderService";
import RequestsService from "@/services/v2/requests.service";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import popoverLastBuy from "@/components/popovers/last-buy.popover";
import WinnerProducts from "@/components/partials/_products";
import SellerReviewModal from "@/modals/seller-review/seller-review.modal";
import { perm_mixin } from "@/mixins/permission.mixin";
import StandardButton from "@/components/ui/buttons/Standard-Button.vue";
import StandardInput from "@/components/ui/inputs/StandardInputAuto.vue";
import AddProductModal from "@/modals/add-new-offer-to-request/add-new-offer-to-request.modal";
import EditOrderDetails from "./EditOrderDetails.vue";

export default {
    mixins: [perm_mixin],
    props: {
        SECTION: {
            type: String,
            default: "TYPINGS",
        },
    },
    components: {
        ccButton: Button,
        ccPagination: Pagination,
        ccProducts: WinnerProducts,
        ProductsMatrixComponent,
        AddProductModal,
        ccTypings: Typings,
        popoverLastBuy,
        "cc-seller-review": SellerReviewModal,
        StandardButton,
        StandardInput,
        EditOrderDetails,
    },
    data() {
        return {
            trigger: false,
            is_loading: false,
            is_loading_provider: false,
            add_product: false,
            show_reviews: false,
            request_detail_obs_editing: false,
            CONSTANTS: CONSTANTS,
            myStore: undefined,
            priceVariationFilter: "",
            priceVariationOptions: [
                { text: "Todos", value: "all" },
                { text: "Aumento de preço", value: "aumento_preco" },
                { text: "Rebaixa de preço", value: "rebaixa_preco" },
                { text: "Preço Igual", value: "preco_igual" },
                { text: "Primeira Compra", value: "primeira_compra" },
            ],
            showEditDetails: false,
            varTotal: 0,
            page: 1,
            backRoute: 1,
            backOrdered: 0,
            total_items: 0,
            backRouteName: "cliente-monitores-vencedores",
            isTextObs: true,
            obsForm: {
                eventNumber: "",
                car: "",
                address: "",
                pix: "",
            },
            sellers: [],
            openedPopovers: [],
            orderService: new OrderService(),
            quotationService: new QuotationService(),
            showPriceManager: 0,
            providerCnpj: this.$route.params.cnpj,
            service: new RequestsService(),
            showDetailsMobile: false,
            current_subrequest: null,
            search_terms: null,
            selected_status_filter: "WINNERS_ONLY",
            quotationId: [],
            subrequests: [],
            all_subrequests: [],
            products: [],
            breadcrumbs: [
                {
                    link: CONSTANTS.ROUTE_MONITORS,
                    name: "Monitor de Cotações",
                },
                {
                    link: CONSTANTS.ROUTE_MONITORS + "/vencedores/" + this.$route.params.id,
                    name: "Cotação " + this.$route.params.id,
                },
                {
                    name: "Pré-Pedidos",
                },
                {
                    name: "Realizar Pedido",
                },
            ],
            loadingPaymentConditions: false,
            apiPaymentCondition: null,
            canAddProducts: false,
            quotationStatus: null,
        };
    },
    methods: {
        updateProductPage(page) {
            this.page = page;
            this.getProducts();
        },
        closeModal() {
            this.add_product = false;
            this.update();
        },
        openProductsModal() {
            this.add_product = true;
        },
        formatNumber(number) {
            if (!number) return null;
            number = number.replace("+", "").replace("(", "").replace(")", "").replace("-", "");
            if (number[0] + "" + number[1] != "55") number = "55" + number;
            return number;
        },
        searchProducts(value) {
            this.search_terms = value;
            this.getProducts(false)
        },
        setPriceVariationFilter(value) {
            this.priceVariationFilter = value;
        },
        visible_products() {
            return this.products.filter((p) => p.visible == undefined || p.visible);
        },
        getActiveSection(text) {
            if (text == this.SECTION) return "makeorder-page-buttons-section-active";
        },
        sendSuplier() {
            this.$router.push({
                name: "request-matrix-overview",
                params: {
                    id: this.$route.params.id,
                    sellerid: this.$route.params.sellerid,
                    providerid: this.$route.params.providerid,
                },
            });
        },
        sendPriceManager() {
            this.$router.push({
                name: "requestPriceManager",
                params: {
                    id: this.$route.params.id,
                    sellerid: this.$route.params.sellerid,
                    providerid: this.$route.params.providerid,
                },
            });
        },
        sendBack() {
            this.$router.push({
                name: this.backRouteName,
                params: {
                    id: this.$route.params.id,
                    tab: "pedidos",
                    request_id: this.$route.params.id,
                },
                query: { po: this.backRoute, o: this.backOrdered },
            });
        },
        toggleOrdersOnlyFilter(toggle) {
            this.SECTION = toggle;
            if (this.SECTION == "PRODUCTS") {
                this.getProducts(this.$route.params.sid);
            }
        },
        print() {
            self.print();
        },
        addNewProduct() { },
        openPopover(popover) {
            this.openedPopovers.push(popover);
            this.$refs[popover][0].style.display = "block";
        },
        closePopover(popover) {
            const index = this.openedPopovers.indexOf(popover);
            if (index > -1) {
                this.openedPopovers.splice(index, 1);
            }
            this.$refs[popover][0].style.display = "none";
        },
        add_new_product(offer) {
            console.log(offer);
        },
        exportPdfOrder() {
            if (this.SECTION == "TYPINGS") {
                let callback = (data) => {
                    var file = new Blob([data], { type: "application/pdf" });
                    var fileURL = URL.createObjectURL(file);
                    var el = document.getElementById("download-pdf");
                    var title = "Pedido-" + this.current_subrequest.id_pedido + ".pdf";
                    if (!this.current_subrequest.id_pedido) {
                        title = "pre-pedido-vendedor.pdf";
                    }
                    el.download = title;
                    el.href = fileURL;
                    el.click();
                    setTimeout(function () {
                        window.URL.revokeObjectURL(fileURL);
                    }, 100);
                    this.is_loading_pdf = false;
                };

                let data = {
                    id_pedido: this.current_subrequest.id_pedido,
                    id_cotacao: this.$route.params.id,
                    id_loja: this.current_subrequest.loj_id,
                    usu_id: this.current_subrequest.vendedor_id,
                };

                this.is_loading_pdf = true;
                this.orderService
                    .exportPdfOrder(data)
                    .then((response) => response.data)
                    .then(callback)
                    .catch((error) => {
                        this.is_loading_pdf = false;
                        ErrorHandlerService.handle(error, this.$store);
                    });
            } else {
                self.print();
            }
        },
        order() {
            let amount =
                this.current_subrequest.total < (this.current_subrequest.faturamento_minimo || 0)
                    ? this.current_subrequest.total - this.current_subrequest.faturamento_minimo
                    : 0;

            let confirmation_text = "<h2 style=''>Confirma realização do pedido?</h2>";
            confirmation_text += "</br><span>Seu pedido será enviado ao fornecedor!</span>";

            if (amount < 0) {
                confirmation_text =
                    "<h2 style='color:#d33'>Atenção! Faturamento minimo não atingido</h2>";
                confirmation_text += "</br><span>Deseja continuar?</span>";
            }

            let data = {
                idcotacao: this.$route.params.id,
                idvendedor: this.$route.params.sellerid,
                loja: this.$route.params.sid,
                obs: this.current_subrequest.obs,
            };
            this.$swal
                .fire({
                    html: confirmation_text,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim, realizar pedido!",
                })
                .then((result) => {
                    if (result.value) {
                        this.is_loading = true;
                        if (this.SECTION == "MATRIX") {
                            delete data["loja"];
                            this.request_order(data).then(() => (this.trigger = !this.trigger));
                        } else {
                            this.request_order(data);
                        }
                    }
                });
        },
        request_order(data, prevent_feedback = false) {
            return this.quotationService
                .order(data)
                .then((response) => response.data)
                .then(
                    (data) => {
                        if (!prevent_feedback) {
                            this.is_loading = false;
                            this.$swal.fire(
                                "Realizado!",
                                "Seu pedido foi realizado com sucesso.",
                                "success"
                            );
                            this.update();
                        }
                    },
                    (err) => {
                        this.is_loading = false;
                        this.$swal.fire("Erro!", err.response?.data?.mensagem ?? "Ocorreu um erro ao realizar o pedido.", "error");
                    }
                );
        },
        save_request_detail_obs() {
            let obs = "";
            if (this.isTextObs) obs = this.current_subrequest.obs;
            else obs = JSON.stringify(this.obsForm);
            let data = {
                obs,
                loj_id: this.current_subrequest.loj_id,
                usu_id: this.current_subrequest.vendedor_id,
            };
            return this.service
                .save_pre_request_details(this.$route.params.id, data)
                .then((response) => response.data)
                .then(
                    (data) => {
                        this.request_detail_obs_editing = false;
                        this.$swal.fire(
                            "Salvo!",
                            "Suas observações foram salvas com sucesso!",
                            "success"
                        );
                    },
                    (err) => {
                        this.$swal.fire("Erro!", "Ocorreu um erro ao salvar observações.", "error");
                    }
                );
        },
        navigate_provider(direction) {
            var s = null;
            for (var i = 0; i < this.subrequests.length; i++) {
                s = this.subrequests[i];
                if (
                    s.vendedor_id == this.$route.params.sellerid &&
                    s.loj_id == this.$route.params.sid &&
                    s.for_id == this.$route.params.providerid
                ) {
                    if (direction == 1) {
                        if (this.subrequests.length > i + 1) {
                            s = this.subrequests[i + 1];
                            break;
                        } else if (this.subrequests.length == i + 1) {
                            s = this.subrequests[0];
                            break;
                        }
                    } else if (direction == -1) {
                        if (i == 0) {
                            s = this.subrequests[this.subrequests.length - 1];
                        } else {
                            s = this.subrequests[i - 1];
                        }
                        break;
                    }
                }
            }
            this.$router.push({
                name: "lancamento-cliente-monitores-vencedores",
                params: {
                    id: this.$route.params.id,
                    sellerid: s.vendedor_id,
                    sid: s.loj_id,
                    providerid: s.for_id,
                },
            });
            this.trigger = !this.trigger;
            this.update();
        },
        cancel_order() {
            let data = {
                numeroCotacao: `${this.$route.params.id}`,
                vendedor: `${this.$route.params.sellerid}`,
                loja: `${this.$route.params.sid}`,
                motivoId: null,
            };
            this.$swal
                .fire({
                    title: "Confirma cancelamento do pedido?",
                    text: "Seu pedido será cancelado!",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim, cancelar pedido!",
                    input: "select",
                    inputOptions: {
                        1: "Quantidade Errada",
                        2: "Valores Divergentes",
                        3: "Ruptura de Produtos",
                        4: "Entrega não realizada",
                        5: "Outros",
                    },
                    inputValidator: (value) => {
                        if (!value) {
                            return "Você precisa escolher um motivo!";
                        }
                    },
                })
                .then((result) => {
                    if (result.value) {
                        data.motivoId = result.value;
                        this.is_loading = true;
                        if (this.SECTION == "MATRIX") {
                            this.all_subrequests.forEach((sub) => {
                                if (
                                    sub.vendedor_id == data.vendedor &&
                                    sub.id_pedido &&
                                    sub.for_id == this.$route.params.providerid
                                ) {
                                    console.log(sub);
                                }
                            });
                            let subs = this.all_subrequests.filter(
                                (sub) =>
                                    sub.vendedor_id == data.vendedor &&
                                    sub.id_pedido &&
                                    sub.for_id == this.$route.params.providerid
                            );
                            subs.forEach((sub, k) => {
                                this.request_order_cancelling(
                                    { ...data, loja: `${sub.loj_id}` },
                                    k + 1 == subs.length
                                ).then(() => {
                                    if (k + 1 == subs.length) {
                                        this.trigger = !this.trigger;
                                    }
                                });
                            });
                        } else {
                            this.request_order_cancelling(data);
                        }
                    }
                });
        },
        request_order_cancelling(data, prevent_feedback = false) {
            return this.quotationService
                .cancel_order(data)
                .then((response) => response.data)
                .then(
                    (data) => {
                        if (!prevent_feedback) {
                            this.$swal.fire(
                                "Sucesso!",
                                "Seu pedido foi cancelado com sucesso.",
                                "success"
                            );
                            this.is_loading = false;
                            this.update();
                        }
                    },
                    (err) => {
                        this.is_loading = false;
                        this.$swal.fire("Erro!", "Ocorreu um erro ao cancelar o pedido.", "error");
                    }
                );
        },
        reload_current_provider(background = false) {
            console.log(background, 'JKHASDKJHAGSKDJAGSJKHDGKAJHSGKJHGSADJKH')
            this.load_subrequests(background).catch((error) =>
                ErrorHandlerService.handle(error, this.$store)
            );
        },
        checkReturnRoute() {
            if (this.current_subrequest) {
                if (!this.current_subrequest.id_pedido) {
                    this.backOrdered = 0;
                } else if (this.current_subrequest.id_pedido) {
                    this.backOrdered = 1;
                }
            }
        },
        search(evt) {
            this.products.forEach((p) => {
                if (
                    new RegExp(this.search_terms, "i").test(p.descricaoProduto) &&
                    this.is_winner(p)
                ) {
                    this.$set(p, "visible", true);
                } else {
                    this.$set(p, "visible", false);
                }
            });
        },
        getProducts(show_loader = true) {
            this.is_loading = show_loader;
            if(show_loader)this.products = [];
            this.service
                .request_report_for_seller_by_store(
                    this.$route.params.id,
                    this.$route.params.sid,
                    {
                        page: this.page,
                        for_id: this.$route.params.providerid,
                        descricao: this.search_terms,
                    }
                )
                .then((response) => response.data)
                .then((data) => {
                    for (var i = 0; i < data.produtos.length; i++) {
                        var embalagem_split = data.produtos[i].embalagem.split(" ");
                        data.produtos[i].embalagem_units = embalagem_split[0];
                        data.produtos[i].embalagem_quantity = embalagem_split[1];
                    }
                    this.total_items = 0;
                    setTimeout(() => {
                        this.total_items = data.valorTotal.totalProdutos;
                    }, 500);
                    this.is_loading = false;
                    this.products = data.produtos;
                    this.filter_products(this.products);
                    this.process_winner_condition(this.products);
                })
                .catch((error) => {
                    this.is_loading = false;
                    if (error.request && error.request.status == 403) {
                        this.$router.push(CONSTANTS.ROUTE_MONITORS);
                    }
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        process_winner_condition(products) {
            this.service
                .winners_map_for(
                    this.$route.params.id,
                    this.$route.params.sid,
                    this.$route.params.sellerid,
                    this.$route.params.providerid
                )
                .then((response) => response.data)
                .then((data) => {
                    products.forEach((p) => {
                        p.vencedores.forEach((winner) => {
                            winner.vencedor_quantidade = data.some(
                                (offer) =>
                                    offer.prod_id == winner.pro_id && offer.vendedor_id == winner.idVendedor
                            )
                                ? 1
                                : 0;
                        });
                    });
                });
        },
        filter_products(products) {
            if (products) {
                Object.values(products).forEach((p) => {
                    p.visible = true;
                    // p.visible = p.vencedores.some(winner => winner.idVendedor == this.$route.params.sellerid && winner.idFornecedor == this.$route.params.providerid)
                });
            }
        },
        update(section = null) {
            // this.loading = true
            this.is_loading_provider = true;
            if (section) {
                this.SECTION = section;
            }
            this.load_subrequests()
                .then(() => {
                    this.checkReturnRoute();
                    this.$forceUpdate();
                    // this.loading = false
                    this.is_loading_provider = false;
                    if (this.current_subrequest && this.SECTION == "PRODUCTS") {
                        this.SECTION = "TYPINGS";
                    }
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        async load_subrequests(background = false) {
            try {
                this.is_loading_provider = !background;

                const response = await this.service.subrequests_with_sellers_for(
                    this.$route.params.id
                );
                const data = response.data;

                this.subrequests = data;
                this.all_subrequests = data;

                let next = this.subrequests.find(
                    (s) =>
                        s.for_id == this.$route.params.providerid &&
                        s.vendedor_id == this.$route.params.sellerid &&
                        s.loj_id == this.$route.params.sid
                );

                if (next) {
                    this.current_subrequest = next;

                    await this.fetchQuotationStatus();

                    if (this.current_subrequest.obs) {
                        try {
                            const form = JSON.parse(this.current_subrequest.obs);
                            this.isTextObs = false;
                            this.obsForm.eventNumber = form.eventNumber;
                            this.obsForm.address = form.address;
                            this.obsForm.car = form.car;
                            this.obsForm.pix = form.pix;
                            this.current_subrequest.obs = `${form.eventNumber} - ${form.address} - ${form.car} - ${form.pix}`;
                        } catch { }
                    }

                    this.sort_subrequests();
                } else {
                    if (!this.current_subrequest) {
                        this.$router.push({
                            name: "cliente-monitores-vencedores",
                            params: { id: this.$route.params.id },
                            query: { po: 1 },
                        });
                    }
                    this.subrequests.push(this.current_subrequest);
                    this.sort_subrequests();
                    this.current_subrequest.total = 0;
                }

                this.is_loading_provider = false;
            } catch (error) {
                this.is_loading_provider = false;
                ErrorHandlerService.handle(error, this.$store);
            }
        },

        async fetchQuotationStatus() {
            try {
                const response = await this.quotationService.list(
                    1,
                    null,
                    null,
                    null,
                    this.$route.params.id,
                    10
                );

                if (
                    response.data &&
                    response.data.cotacoes &&
                    response.data.cotacoes.data.length > 0
                ) {
                    const cotacao = response.data.cotacoes.data[0];
                    this.current_subrequest.status = cotacao.status;
                    this.quotationStatus = cotacao.status;
                } else {
                    this.current_subrequest.status = null;
                }
            } catch (error) {
                console.error("Erro ao buscar status da cotação:", error);
                this.current_subrequest.status = null;
            }
        },

        sort_subrequests() {
            let result = [];
            let loj_ids = Array.from(new Set(this.subrequests.map((s) => s.loj_id)));
            for (let id of loj_ids) {
                result = result.concat(
                    this.subrequests
                        .filter((s) => s.loj_id == this.$route.params.sid)
                        .sort((a, b) => {
                            return a.for_nome.localeCompare(b.for_nome);
                        })
                );
            }
            this.subrequests = result;
        },
        update_breadcrumbs() {
            this.$store.dispatch("set_breadcrumbs", [
                { name: "Painel de Operações", route: "monitors-page" },
                { name: "Cotações", route: "monitors-page" },
                { name: `#${this.$route.params.id}`, route: "cliente-monitores-vencedores" },
                { name: "detalhes" },
            ]);
        },
        async fetchPaymentConditions() {
            try {
                this.loadingPaymentConditions = true;
                const response = await this.quotationService.list(
                    1,
                    null,
                    null,
                    null,
                    this.$route.params.id,
                    10
                );

                this.apiPaymentCondition = null;

                if (response.data && response.data.cotacoes && response.data.cotacoes.data) {
                    const cotacao = response.data.cotacoes.data[0];
                    this.apiPaymentCondition = cotacao.ttp_nome;

                    if (this.current_subrequest) {
                        this.current_subrequest.status = cotacao.status;
                    }
                }
            } catch (error) {
                console.error("Erro ao buscar condições:", error);
            } finally {
                this.loadingPaymentConditions = false;
            }
        },

        showPaymentConditionAlert(provider) {
            if (!provider.forma) {
                return false;
            }

            const isApiConditionInvalid =
                this.apiPaymentCondition === null ||
                this.apiPaymentCondition === undefined ||
                this.apiPaymentCondition === "";

            if (isApiConditionInvalid) {
                return false;
            }

            const providerForma = provider.forma.toLowerCase().trim();
            const apiForma = this.apiPaymentCondition.toLowerCase().trim();
            return providerForma !== apiForma;
        },
        canAddProductsNow() {
            if (
                !this.current_subrequest ||
                this.current_subrequest.status === undefined ||
                this.current_subrequest.status === null
            ) {
                return false;
            }
            const result =
                this.current_subrequest.status === 10 || this.current_subrequest.status === 4;
            return result;
        },
    },
    created() {
        this.showPriceManager = localStorage.getItem("cli_utilizaPrecoBase") == 1;
        this.update();
        this.update_breadcrumbs();
        if (this.$route.query.backRoute == 2) {
            this.backRoute = 2;
            this.backRouteName = this.$route.params.backRouteName;
        }
        this.perms.forEach((element) => {
            if (element.resource == "MY_COMPANY" && element.action == "READ") {
                this.myStore = true;
            }
        });
    },
    computed: {
        canCancelOrder() {
            return !this.perms.some(
                (perm) =>
                    perm.resource === "REQUEST_ORDER" &&
                    perm.action === "CANCEL" &&
                    perm.subject_ids === null
            );
        },
    },
    watch: {
        current_subrequest: {
            handler(newVal) {
                if (newVal) {
                    this.fetchPaymentConditions();
                }
            },
            immediate: true,
        },
        "current_subrequest.status": {
            handler(newStatus) {
                if (newStatus !== undefined && newStatus !== null) {
                    this.canAddProducts = newStatus === 10 || newStatus === 4;
                } else {
                    this.canAddProducts = false;
                }
            },
            immediate: true,
        },
    },
    mounted() {
        this.fetchPaymentConditions();
    },
};
</script>

<style lang="scss" scoped>
@import "./details.page";
@import "@/sass/commons/_variables";
</style>
